import React, { useEffect, useState } from 'react';
import './AIBinaryBackground.css';

const AIBinaryBackground = () => {
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        const columnCount = 20;
        const newColumns = Array.from({ length: columnCount }).map(() => ({
            id: Math.random(),
            bits: Array.from({ length: 20 }).map(() => Math.round(Math.random())),
            delay: Math.random() * 5,
            duration: 3 + Math.random() * 7,
            left: Math.random() * 100
        }));
        setColumns(newColumns);
    }, []);

    return (
        <div className="ai-binary-background">
            {columns.map((col) => (
                <div
                    key={col.id}
                    className="binary-column"
                    style={{
                        left: `${col.left}%`,
                        animationDelay: `${col.delay}s`,
                        animationDuration: `${col.duration}s`
                    }}
                >
                    {col.bits.map((bit, i) => (
                        <div key={i} className="binary-bit">{bit}</div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default AIBinaryBackground;
